import Vue from 'vue'
import Router from 'vue-router'
//直播课堂
import index from '@/components/index/index'
import zplay from '@/components/index/zplay'
import dplay from '@/components/index/dplay'
import gclass from '@/components/index/record'
import period from '@/components/index/period'
import liveList from '@/components/index/liveList'
import live from '@/components/index/live'
import addCourse from '@/components/index/addCourse'
Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/dplay',
			name: 'dplay',
			component: dplay,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '课程中心',
			}
		},
		{
			path: '/zplay',
			name: 'zplay',
			component: zplay,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '爱慧直播',
			}
		},
		{
			path: '/liveList',
			name: 'liveList',
			component: liveList,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '爱慧直播',
			}
		},
		{
			path: '/index',
			name: 'index',
			component: index,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '爱慧课程',
			}
		},
		{
			path: '/gclass',
			name: 'gclass',
			component: gclass,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '观课记录',
			}
		},
		{
			path: '/period',
			name: 'period',
			component: period,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '观课记录',
			}
		},
		{
			path: '/live',
			name: 'live',
			component: live,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '直播',
			}
		},
		{
			path: '/addCourse',
			name: 'addCourse',
			component: addCourse,
			meta: {
				keepAlive: false,
				isBack: true,
				title: '添加课程',
			}
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition
		} else {
			if(from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop
			}
			return {
				x: 0,
				y: to.meta.savedPosition || 0
			}
		}
	},
})


// WEBPACK FOOTER //
// ./src/router/index.js